import { isProtectedDemoViewer } from "@nimbus-erp/shared";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

export function ForbiddenPage() {
  const navigate = useNavigate();
  const isDemoViewer = useAuthStore(
    (state) => isProtectedDemoViewer(state.user),
  );
  return (
    <Result
      status="403"
      title="无权访问此功能"
      subTitle={isDemoViewer
        ? "当前是只读演示账号，可以浏览业务数据，但没有此功能的操作或查看权限。需要完整操作时请使用获授权的正式账号。"
        : "当前账号未获得所需权限。如职责已变化，请联系企业管理员调整角色。"}
      extra={
        <Button type="primary" onClick={() => navigate("/workspace")}>
          返回工作台
        </Button>
      }
    />
  );
}
